import UKFlag from 'assets/flags/uk.png';
import INFlag from 'assets/flags/india.png';


// companyInfoFields.ts
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/
  ///^\d{0,2}+(\.\d{0,2})?$/
}


export const companyInfoFields = [
  {
    id: "clientName",
    label: "Client Name",
    placeHolder: "Enter client name",
    type: "text",
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly: true,
    md: 12
  },
  {
    id: "companyName",
    label: "Company Name",
    placeHolder: "Enter company name",
    type: "text",
    isRequired: true,
    editReadOnly: true
  },
 
  {
    id: "phoneNumber",
    label: "Phone Number",
    placeHolder: "Enter phone number",
    type: "contact",
    // isRequired: true,
    // options:[
    //   {value:"+44", label:"+44", icon: UKFlag}, // UK
    //   {value:"+91", label:"+91", icon: INFlag}, // India
    // ],
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC
  },
  {
    id: "address",
    label: "Registered Address",
    placeHolder: "Enter Address",
    type: "text",
    isRequired: true,
  },
  {
    id: "postCode",
    label: "Registered Post Code",
    placeHolder: "Enter Postcode",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 8,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "transportCode",
    label: "Transport Code",
    placeHolder: "Enter Postcode",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 8,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "correspondingAddress",
    label: "Corresponding Address",
    placeHolder: "Enter Address",
    type: "text",
    // isRequired: true,
  },
  {
    id: "correspondingPostCode",
    label: "Corresponding Post Code",
    placeHolder: "Enter Postcode",
    type: "text",
    inputProps: {
      maxLength: 8,
    },
    // isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "companyStrapLine",
    label: "Company Strap Line",
    placeHolder: "Enter company description",
    type: "text",
  },
  {
    id: "vatRegNoOptions",
    label: "Do you have a VAT Registration No.?",
    type: "radio", // Define as radio button
    options: [], // Define the options
  
    isRequired: true,
  },
  {
    id: "vatRegNo",
    label: "VAT Reg. No.",
    placeHolder: "Enter VAT Reg. No.",
    type: "string",
    isRequired: true,
    editReadOnly: true,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "vatPercent",
    label: "VAT Percentage",
    placeHolder: "Enter VAT Percentage",
    type: "text",
    isRequired: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    editReadOnly: true
  },
  {
    id: "dateFormat",
    label: "Date Format",
    placeHolder: "Select",
    type: "select",
    options: [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY/MM/DD",
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
    ],
    isRequired: true,
  },
  {
    id: "timezone",
    label: "Time Zone",
    placeHolder: "select",
    type: "select",
    options: [
      "Europe/London",
      "Asia/Kolkata",
    ],
    // isRequired: true,
  },
  {
    id: "companyRegNo",
    label: "Company Reg. No.",
    placeHolder: "Enter company reg. no.",
    type: "text",
    patternAllowed: patternConstant?.ALPHANUMERIC,
    
  },
  {
    id: "registrationDate",
    label: "Registration Date",
    placeHolder: "Select",
    type: "date",
  },
  {
    id: "generalWebsite",
    label: "General Website",
    placeHolder: "Enter general website",
    type: "text",
  },
];

// subscription plan
export const subscriptionPlanFields = [
  {
    id: "planId",
    label: "Subscription",
    placeHolder: "select",
    type: "select",
    options: [],
  },
  {
    id: "duration",
    label: "Frequency",
    placeHolder: "select",
    type: "select",
    options: ["5 Days Trial", "3 Months", "6 Months", "12 Months"],
  },
  {
    id: "term",
    label: "Term",
    placeHolder: "select",
    type: "daterange",
    disablePast: true
  },
  {
    id: "renewsOn",
    label: "Renews On",
    placeHolder: "Enter action",
    type: "text",
    disabled: true
  },
  {
    id: "subscriptionCost",
    label: "Subscription Cost",
    placeHolder: "Enter subscription cost",
    type: "number",
    disabled: true
  },
  {
    id: "discount",
    label: "Discount",
    placeHolder: "Enter discount",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE
  },
  {
    id: "amountPayable",
    label: "Amount Payable",
    placeHolder: "Enter payable amount",
    type: "number",
    disabled: true,
  },
  {
    id: "paymentMethod",
    label: "Payment Method",
    placeHolder: "select",
    type: "select",
    options: ["Direct Debit"],
  },
  // {
  //   id: "cardNumber",
  //   label: "Card Number",
  //   placeHolder: "Enter card number",
  //   type: "text",
  // },
  // {
  //   id: "expiryDate",
  //   label: "Expiry Date",
  //   placeHolder: "select",
  //   type: "date",
  // },
];

// financial Info
export const FinancialInfoFields = [
  {
    id: "invoiceAddress",
    label: "Invoice Address",
    placeHolder: "Enter invoice address",
    type: "text",
    isRequired: true,
  },
  {
    id: "isSameWithCompanyAddress",
    label: "Same as the company's",
    placeHolder: "select",
    type: "checkbox",
  },
  {
    id: "paymentTerms",
    label: "Payment Terms",
    placeHolder: "Enter payment terms",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    isRequired: true,
  },
  {
    id: "bankSortCode",
    label: "Bank Sort Code",
    placeHolder: "Enter bank sort code",
    type: "text",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "bankAccountNumber",
    label: "Bank Account No.",
    placeHolder: "Enter bank account number",
    type: "text",
    inputProps: {
      maxLength: 12,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "accountHolderName",
    label: "Account Holder Name",
    placeHolder: "Enter account holder name",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "IBAN",
    label: "IBAN",
    placeHolder: "Enter iban number",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
  },
  {
    id: "swiftNumber",
    label: "SWIFT No.",
    placeHolder: "Enter swift number",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
  },
  {
    id: "bankName",
    label: "Bank Name",
    placeHolder: "Enter bank name",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
  },
  {
    id:'invoiceDueDays',
    label:'Invoice Due Days',
    placeHolder:'Enter invoice due days',
    type:'text',
    patternAllowed: patternConstant?.NUMERIC,
    inputProps:{
      maxLength:3
    }
    // info:'Number of days after which the invoice is due.'
  },
  {
    id: "depositPaymentPercent",
    label: "Deposit Payment %",
    placeHolder: "Enter deposit payment percent",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE,
    // info:"This is the percentage of the total removal cost that is required as a deposit to secure the booking."
  },
  {
    id: "extendedLiabilityPercent",
    label: "Insurance/Liability %",
    placeHolder: "Enter extend liability",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE,
    info:"This is the percentage of the total removal cost that is charged for insurance on international and some UK jobs."
  },
  {
    id: "extendedLiabilityTax",
    label: "Insurance/Liability premium Tax",
    tooltipText:"Insurance/Liability premium Tax",
    placeHolder: "Enter extend liability tax",
    type: "text",
    editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    info:'An amount the company charges on all removals.',
  },
  {
    id: "insuranceFixedRate",
    label: "Insurance/Liability Fixed Rate",
    tooltipText:"Insurance/Liability Fixed Rate",
    placeHolder: "Enter insurance fixed rate",
    type: "text",
     editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    info:'This is a mandatory tax that must be charged when insurance is sold, not Liability Cover. '
  },
];

//Email Settings
export const emailSettingFields = [
  {
    id: "email",
    label: "Contact Email",
    placeHolder: "Enter email ID",
    type: "text",
    isRequired: true,
    editReadOnly: true
  },
  {
    id: "notificationEmail",
    label: "Customer Service",
    placeHolder: "Enter email ID",
    type: "text",
    autocomplete: "off"
  },
   {
    id: "accountsEmail",
    label: "Accounts Email",
    placeHolder: "Enter email ID",
    type: "text",
    autocomplete: "off"
  },
  // {
  //   id: "emailPassword",
  //   label: "Email Password",
  //   placeHolder: "Enter email ID",
  //   type: "password",
  //   autocomplete: "off"
  // },
  {
    id: "emailSignature",
    label: "Email Signature",
    placeHolder: "Enter email signature",
    type: "text",
    autocomplete: "off"
  },
  {
    id: "emailDisclaimer",
    label: "Email Disclaimer",
    placeHolder: "Enter disclaimer",
    type: "text",
    autocomplete: "off"
  },
];
